<template>
	<sui-form @submit.prevent>
		<sui-form-field>
			<label v-if="!sinTitulo" :class="{ [$style.titulo]: true, [$style.boldFont]: true }">
				{{
				titulo
				}}
			</label>
			<sui-dropdown
				ref="select"
				v-model="value"
				fluid
				:class="{ 'disabled': disabled }"
				:options="optionsDias"
				:placeholder="placeholder"
				:value="value"
				selection
				search
				:loading="loading"
				:no-results-message="mensajeVacio"
				@input="onInput"
				@change="onChange"
			/>
			<div style="margin-top: 5px;">
				<span v-show="error" :class="$style.danger">
					<sui-icon name="exclamation circle" />
					{{mensajeError}}
				</span>
			</div>
		</sui-form-field>
	</sui-form>
</template>

<script>
export default {
	props: {
		placeholder: {
			type: String,
			default: 'Selecciona un día'
		},
		titulo: {
			type: String,
			default: 'Día'
		},
		mensajeVacio: {
			type: String,
			default: 'No se encontraron días'
		},
		mensajeError: {
			type: String,
			default: 'Dato obligatorio'
		},
		error: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		selected: {
			type: String,
			default: null
		},
		sinTitulo: {
			type: Boolean,
			default: false
		},
		value:{
			type: String,
			default: ''
		}
	},
	data() {
		return {
			dia: null,
			optionsDias: [
				{
					text: 'Lunes',
					value: 'LU'
				},
				{
					text: 'Martes',
					value: 'MA'
				},
				{
					text: 'Miércoles',
					value: 'MI'
				},
				{
					text: 'Jueves',
					value: 'JU'
				},
				{
					text: 'Viernes',
					value: 'VI'
				},
				{
					text: 'Sábado',
					value: 'SA'
				},
				{
					text: 'Domingo',
					value: 'DO'
				}
			]
		};
	},
	methods: {
		onChange(value) {
			this.$refs.select.filter = '';
			this.$emit('change', value);
		},
		onInput(val) {
			this.$emit('input', val);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.titulo {
	font-size: 14px !important;
	color: #5c5d5d !important;
}
.danger {
	color: #9f2241 !important;
}
</style>
